import { createFileRoute, notFound } from "@tanstack/react-router";
import { getContactSettings } from "@/lib/server-functions";
import ContactPage from "@/pages/Contact";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { contactJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/contact")({
  loader: async () => {
    try {
      const settings = await getContactSettings();
      return { settings };
    } catch {
      throw notFound();
    }
  },

  head: ({ loaderData }) => {
    const pageUrl = getPageUrl("/contact");

    return {
      meta: [
        { title: "Contact KNMC Hospital — Kathmandu, Nepal" },
        {
          name: "description",
          content:
            "Contact Kathmandu National Medical College & Teaching Hospital in Kathmandu, Nepal. Address, phone, email, 24/7 emergency line and directions.",
        },
        {
          name: "keywords",
          content:
            "contact KNMC, hospital address Kathmandu, emergency number Nepal, KNMC phone, hospital location Kathmandu",
        },
        {
          property: "og:title",
          content: "Contact KNMC — Kathmandu, Nepal",
        },
        {
          property: "og:description",
          content:
            "Reach KNMC Hospital in Kathmandu — appointments, queries and 24/7 emergency contact.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        contactJsonLd(loaderData?.settings ?? null),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { settings } = Route.useLoaderData();
    return <ContactPage settings={settings} />;
  },
});